import { formatDecimalInput as formatLocalizedDecimalInput } from './currency';

export const formatEmailInput = (value = '') => String(value).replace(/\s+/g, '').toLowerCase();

export const formatPhoneInput = (value = '', language = 'pt-BR') => {
  const digits = String(value).replace(/\D/g, '').slice(0, 15);
  const normalizedLanguage = String(language || 'pt-BR').toLowerCase();

  if (normalizedLanguage.startsWith('es')) {
    const local = digits.length > 9 ? digits.slice(-9) : digits;
    const countryPrefix = digits.length > 9 ? `+${digits.slice(0, digits.length - 9)} ` : '';
    if (local.length <= 3) return `${countryPrefix}${local}`.trim();
    const first = local.slice(0, 3);
    const second = local.slice(3, 6);
    const third = local.slice(6, 9);
    return `${countryPrefix}${first}${second ? ` ${second}` : ''}${third ? ` ${third}` : ''}`.trim();
  }

  if (normalizedLanguage.startsWith('en')) {
    const local = digits.length > 10 ? digits.slice(-10) : digits;
    const countryPrefix = digits.length > 10 ? `+${digits.slice(0, digits.length - 10)} ` : '';
    if (local.length <= 3) return `${countryPrefix}${local}`.trim();
    const area = local.slice(0, 3);
    const first = local.slice(3, 6);
    const second = local.slice(6, 10);
    return `${countryPrefix}(${area}) ${first}${second ? `-${second}` : ''}`.trim();
  }

  if (digits.length <= 2) return digits;
  const countryPrefix = digits.length > 11 ? `+${digits.slice(0, digits.length - 11)} ` : '';
  const local = digits.length > 11 ? digits.slice(-11) : digits;
  const area = local.slice(0, 2);
  const first = local.length > 10 ? local.slice(2, 7) : local.slice(2, 6);
  const second = local.length > 10 ? local.slice(7, 11) : local.slice(6, 10);
  return `${countryPrefix}(${area}) ${first}${second ? `-${second}` : ''}`.trim();
};

export const formatDecimalInput = (value = '', language = 'pt-BR') => formatLocalizedDecimalInput(value, language);


export const formatTimeInput = (value = '') => {
  const digits = String(value).replace(/\D/g, '').slice(0, 4);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}:${digits.slice(2)}`;
};

export const formatDocumentInput = (value = '') => String(value).slice(0, 20);
